module.exports = __webpack_public_path__ + "static/media/bonusOnDeposit.4da153f0.png";